:host {
  display: block;
  max-width: 100%;
  height: auto;
}

.wrapper {
  flex-direction: column;
  position: relative;
}

#title {
  color: var(--main-titles-inputs-600);
  padding-bottom: calc(var(--spacer) + 2px);
}

#description {
  padding-bottom: calc(var(--spacer) * 2 + 2px);
}

gz-text[id*=description] {
  min-width: 600px;
  max-width: 600px;
}

